
import { Card } from '@/components/ui/card';
import { BuildingIcon } from 'lucide-react';

export const PEODashboardLoader = () => (
  <div className="min-h-screen bg-gradient-to-br from-white to-gray-50 p-6">
    <div className="max-w-7xl mx-auto space-y-8">
      <div className="flex justify-between items-center bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
        <div className="flex items-center gap-3">
          <div className="bg-primary/10 p-2 rounded-lg">
            <BuildingIcon className="h-6 w-6 text-primary" />
          </div>
          <h1 className="text-3xl font-bold bg-gradient-to-r from-primary to-primary-light bg-clip-text text-transparent">
            PEO Provider Dashboard
          </h1>
        </div>
        <div className="flex gap-3">
          <div className="w-24 h-10 rounded-md bg-gray-100 animate-pulse"></div>
          <div className="w-24 h-10 rounded-md bg-gray-100 animate-pulse"></div>
        </div>
      </div>
      
      {/* Shimmer loader for provider profile */}
      <Card className="border border-gray-100 shadow-sm p-6">
        <div className="space-y-4">
          <div className="h-8 w-64 bg-gray-100 rounded animate-pulse"></div>
          <div className="grid grid-cols-2 gap-4 mt-4">
            <div>
              <div className="h-4 w-32 bg-gray-100 rounded mb-2 animate-pulse"></div>
              <div className="h-10 bg-gray-100 rounded animate-pulse"></div>
            </div>
            <div>
              <div className="h-4 w-32 bg-gray-100 rounded mb-2 animate-pulse"></div>
              <div className="h-10 bg-gray-100 rounded animate-pulse"></div>
            </div>
          </div>
        </div>
      </Card>

      {/* Shimmer loader for quotes list */}
      <Card className="border border-gray-100 shadow-sm">
        <div className="p-6 border-b border-gray-100">
          <div className="h-7 w-40 bg-gray-100 rounded animate-pulse"></div>
        </div>
        <div className="p-6">
          <div className="space-y-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex items-center justify-between py-2">
                <div className="h-6 w-48 bg-gray-100 rounded animate-pulse"></div>
                <div className="h-6 w-20 bg-gray-100 rounded animate-pulse"></div>
                <div className="h-6 w-20 bg-gray-100 rounded animate-pulse"></div>
                <div className="h-6 w-24 bg-gray-100 rounded animate-pulse"></div>
                <div className="h-6 w-24 bg-gray-100 rounded animate-pulse"></div>
                <div className="flex gap-2">
                  <div className="h-9 w-28 bg-gray-100 rounded animate-pulse"></div>
                  <div className="h-9 w-28 bg-gray-100 rounded animate-pulse"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Card>
    </div>
  </div>
);
